import { createSchema } from 'morphism';

export default {
  generateReport: createSchema(
    {
      emails: source => source?.emails?.join(',') || undefined,
      filters: 'filters'
    },
    { undefinedValues: { strip: true } }
  )
};
